<template>
  <div class="container">
    <div class="col-wrapper">
      <div class="col">
        <div class="col-header">
          <p>Welcome to Mail Template!</p>
          <span>
            Many of us are so used to workin on a computer descktop that
            when it comes time to purchase a new computer, we don't consider other options.
          </span>
        </div>
        <div class="dashboard-container">
          <div class="chart-container">
            <card-componet class="first">
              <alert-weekly-line
                :options="{responsive: false, maintainAspectRatio: false}"
                :width="1000"
                :height="280"
                :data="chartData"
              ></alert-weekly-line>
              <div class="search-container">
                <search-input
                  class="search-input"
                  type="text"
                  v-model="Searched"
                  placeholder="Search"
                />
                <secondary-button @click.native="getSmsReports" class="secondary-button">Filter</secondary-button>
              </div>
              <div class="resellers-table table-header">
                <div>
                  <span>Company</span>
                </div>
                <div>
                  <span>Date</span>
                </div>
                <div>
                  <span>SMS</span>
                </div>
              </div>
              <div v-for="(alert, k) in alerts" :key="k" class="resellers-table table-body">
                <div>
                  <span>{{alert.companyName}}</span>
                </div>
                <div>
                  <span>{{alert.date}}</span>
                </div>
                <div>
                  <span>{{alert.smsCount}}</span>
                </div>
              </div>
              <p @click="showMore" class="pagination-link">Show more</p>
            </card-componet>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="col-container">
          <nav class="navigation">
            <div class="nav-header">Credit Below Limit</div>
            <primary-select type="text" class="select-days" v-validate="'required'">
              <option value disabled hidden selected>Last 7 days</option>
            </primary-select>
          </nav>
          <div class="resellers-table table-header">
            <div>
              <span>Title</span>
            </div>
            <div>
              <span>Date</span>
            </div>
            <div>
              <span>Status</span>
            </div>
          </div>
          <div v-for="(company, k) in companies" :key="k" class="resellers-table table-body">
            <div>
              <span>{{company.companyName}}</span>
            </div>
            <div>
              <span>{{company.date}}</span>
            </div>
            <div>
              <span>
                <secondary-button
                  :class="(company.status == 'inactive') ? 'rejected' : 'active'"
                >{{company.status == 'inactive' ? 'Not Active' : 'Active'}}</secondary-button>
              </span>
            </div>
          </div>
        </div>
        <div class="col-container">
          <nav class="navigation">
            <div class="nav-header">Invoice</div>
          </nav>
          <div class="resellers-table invoice table-header">
            <div>
              <span>Created</span>
            </div>
            <div class="company">
              <span>Company</span>
            </div>
            <div>
              <span>Paid</span>
            </div>
            <div class="amount">
              <span>Amount</span>
            </div>
          </div>
          <div v-for="(invoice, k) in invoices" :key="k" class="resellers-table table-body invoice">
            <div>
              <span>{{invoice.date}}</span>
            </div>
            <div class="company">
              <span>
                <img class="popup_image" src="@/assets/person.jpg" alt />
                {{invoice.companyName}}
              </span>
            </div>
            <div>
              <span>{{invoice.paid}}</span>
            </div>
            <div class="amount">
              <span>{{invoice.amount}}</span>
            </div>
          </div>
        </div>
        <div class="col-container">
          <nav class="navigation">
            <div class="nav-header">Payment Received</div>
          </nav>
          <div class="resellers-table invoice table-header">
            <div>
              <span>Created</span>
            </div>
            <div class="company">
              <span>Company</span>
            </div>
            <div>
              <span>Description</span>
            </div>
            <div class="amount">
              <span>Amount</span>
            </div>
          </div>
          <div v-for="(invoice, k) in invoices" :key="k" class="resellers-table table-body invoice">
            <div>
              <span>{{invoice.date}}</span>
            </div>
            <div class="company">
              <span>
                <img class="popup_image" src="@/assets/person.jpg" alt />
                {{invoice.companyName}}
              </span>
            </div>
            <div>
              <span>{{invoice.paid}}</span>
            </div>
            <div class="amount">
              <span>{{invoice.amount}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    AlertWeeklyLine: () => import("@/components/Charts/Alert/AlertWeeklyLine"),
    CardComponet: () => import("@/components/CardComponent.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    alerts: [],
    perPage: 10,
    Searched: "",
    resellers: [
      { company: "Nellie Ferguson", date: "29 Apr 2018", sms: 97322 },
      { company: "Lou Haynes", date: "06 Nov 2018", sms: 97322 },
      { company: "Nellie Ferguson", date: "29 Apr 2018", sms: 97322 },
    ],
    arraWeeks: [],
    total: null,
    invoices: [],
    companies: [],
  }),
  computed: {
    chartData() {
      var date = new Date(2019, 0);
      let month = format(date, "M");
      let year = date.getFullYear();
      let last_day = this.daysInMonth(month, year);
      var count =
        last_day == 28
          ? this.weeksCount(year, month) - 1
          : this.weeksCount(year, month) + 1;
      var arraWeeks = new Array(count);
      arraWeeks.fill(0);
      arraWeeks = arraWeeks.map((i, k) => {
        return k == 0
          ? "1st"
          : 7 * k + 1 > last_day
          ? last_day + this.nth(last_day)
          : 7 * k + 1 + this.nth(7 * k + 1);
      });
      var smsCountValues = new Array(count);
      smsCountValues.fill(0);
      console.log("this.arraWeeks", arraWeeks);
      this.alerts.map((item) => {
        var weekOfMonth = this.getWeekOfMonth(item.date);
        smsCountValues[weekOfMonth] += item.smsCount;
      });
      return { arraWeeks, smsCountValues };
    },
  },
  created() {
    this.getSmsReports();
    this.GetList();
    this.GetCompanyList();
  },
  methods: {
    GetList(search, page) {
      this.$store
        .dispatch("GetInvoiceList", {
          page: page,
          perPage: 10,
        })
        .then((res) => {
          this.invoices = res.items.map(this.transformInvoices);
          console.log("invoices", this.invoices);
          //this.TotalPages = res.total / res.per_page;
        });
    },
    transformInvoices(i, k) {
      return {
        invoiceId: i.invoice_uuid,
        companyName: i.company_name,
        date: format(i.created_on, "D MMM YYYY"),
        paid: format(i.invoice_end_date, "D MMM YYYY"),
        amount: i.unpaid_amount,
      };
    },
    GetCompanyList(search, page) {
      this.$store
        .dispatch("GetCompanyList", {
          page: page,
          perPage: 5,
          is_below_credit_limit: false,
        })
        .then((res) => {
          this.companies = res.items.map(this.transformCompanies);
          console.log("companies", this.companies);
          //this.TotalPages = res.total / res.per_page;
        });
    },
    transformCompanies(i, k) {
      return {
        companyId: i.company_uuid,
        companyName: i.company_name,
        date: format(i.created_on, "D MMM YYYY"),
        status: i.status,
        // paid: format(i.invoice_end_date, 'D MMM YYYY'),
        // amount: i.unpaid_amount,
      };
    },
    nth(n) {
      return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
    },
    getWeekOfMonth(date) {
      var thiss = new Date(date);

      var dayOfMonth = thiss.getDay();
      var month = thiss.getMonth();
      var year = thiss.getFullYear();
      var checkDate = new Date(year, month, thiss.getDate());
      var checkDateTime = checkDate.getTime();
      var currentWeek = 0;

      for (var i = 1; i < 32; i++) {
        var loopDate = new Date(year, month, i);

        if (loopDate.getDay() == dayOfMonth) {
          currentWeek++;
        }

        if (loopDate.getTime() == checkDateTime) {
          return currentWeek;
        }
      }
    },
    weeksCount(y, m) {
      var first = new Date(y, m, 1).getDay();
      var last = 32 - new Date(y, m, 32).getDate();

      return Math.ceil((first + last) / 7);
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    transformAlerts(i, k) {
      return {
        companyName: i.company_name,
        date: format(i.date, "D MMM YYYY"),
        smsCount: i.sms_count,
      };
    },
    transformChartData({ smsCount }, k) {
      return {
        smsCount,
      };
    },
    showMore() {
      this.perPage = this.perPage + 10;

      if (this.total < this.perPage) return;

      let date = new Date();
      let month = format(date, "MM");
      let year = date.getFullYear();
      let last_day = this.daysInMonth(month, year);
      this.$store
        .dispatch("getSmsReport", {
          per_page: this.perPage,
          company_name: this.Searched,
          year: year,
          month: month,
          last_day: last_day,
        })
        .then((res) => {
          this.total = res.data.payload.total;
          this.alerts = res.data.payload.items.map(this.transformAlerts);
        });
    },
    getSmsReports() {
      let date = new Date();
      let month = format(date, "MM");
      let year = date.getFullYear();
      let last_day = this.daysInMonth(month, year);
      this.$store
        .dispatch("getSmsReport", {
          per_page: this.perPage,
          company_name: this.Searched,
          last_day: last_day,
          month: month,
          year: year,
        })
        .then((res) => {
          this.alerts = res.data.payload.items.map(this.transformAlerts);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 15px;
  .col-wrapper {
    width: 100%;
    height: fit-content;
    display: flex;
    justify-content: space-between;
    display: flex;
    .col {
      width: 50%;
      padding: 0;
      margin: 0 15px;
      .col-header {
        margin-bottom: 15px;
        p {
          font-size: 16px;
          font-weight: 600;
          color: #000000;
        }
        span {
          font-size: 14px;
          font-weight: normal;
        }
      }
      .col-container {
        background-color: #ffffff;
        padding: 15px;
        margin-bottom: 20px;
        .navigation {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
          width: 100%;
          margin-bottom: 20px;
          .nav-header {
            font-family: "" Helvetica Neue "";
            font-size: 16px;
            line-height: 20px;
            color: #55616e;
          }
          .select-days {
            width: 150px;
          }
        }
      }
      .dashboard-container {
        background-color: #ffffff;
        .chart-container {
          display: flex;
          margin-bottom: 20px;
          .search-container {
            margin-top: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 36px;
            .search-input {
              height: 36px;
              width: 417px;
            }
            .secondary-button {
              height: 36px;
              width: 80px;
            }
          }
          .pagination-link {
            cursor: pointer;
            margin-top: 10px;
            text-align: center;
            color: #51a3f3;
            font-family: "Helvetica Neue";
            font-size: 13px;
            line-height: 15px;
          }
        }
      }
      .resellers-table {
        height: 37px;
        display: flex;
        align-items: center;
        padding: 0 15px 0 15px;
        box-shadow: inset 0 -1px 0 0 #dfe3e8;
        div {
          width: 34%;
        }
      }
      .invoice {
        div {
          width: 25%;
        }
        .company {
          width: 50%;
        }
        .amount {
          padding-left: 10px;
          font-family: "Helvetica Neue";
          color: #000;
          font-weight: 700;
        }
      }
      .table-header {
        color: #212b36;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 16px;
        color: #000;
        font-weight: 600;
      }
      .table-body {
        color: #212b36;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 20px;
        justify-content: left;
        .status {
          border: 2px solid #ffffff;
          border-radius: 100px;
          box-sizing: border-box;
          padding: 2px 8px 2px 8px;
          width: fit-content;
          font-family: "Helvetica Neue";
          font-size: 13px !important;
          line-height: 16px;
        }
        .rejected {
          box-sizing: border-box;
          height: 24px;
          width: 100px;
          border: 2px solid #ffffff;
          border-radius: 100px;
          background-color: #d2305b;
          color: #ffffff;
          font-family: "Helvetica Neue";
          font-size: 13px;
          font-weight: normal;
          line-height: 16px;
          padding: 4px 10px;
        }
        .active {
          box-sizing: border-box;
          height: 24px;
          width: 100px;
          border: 2px solid #ffffff;
          border-radius: 100px;
          background-color: #24e2b8;
          color: #ffffff;
          font-family: "Helvetica Neue";
          font-size: 13px;
          font-weight: normal;
          line-height: 16px;
          padding: 4px 10px;
        }
        .popup_image {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>

